
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30716',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30716",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55226",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8277",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11733",
  "I18n": "static-7.1663",
  "quartz": "static-1.7371",
  "quartz-config": "static-1.1149",
  "quartz-core": "static-1.6590",
  "react-dlb": "static-1.85",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.871",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55213",
  "feedback-utils": "static-1.55217",
  "forms-embed-utils-lib": "static-1.4716",
  "forms-utils-lib": "static-1.13023",
  "foundations-assets": "static-1.5128",
  "foundations-components": "static-1.8391",
  "foundations-theming": "static-1.4707",
  "hub-http": "static-1.6464",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12040",
  "icons": "static-2.674",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4097",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.8",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5519",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.495",
  "tinymce-plugins": "static-1.58121",
  "transmute": "static-2.85",
  "ui-images": "static-2.1230",
  "UIComponents": "static-3.8679",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3581",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3648",
  "quartz-webpack": "static-1.3595",
  "foundations-theming-specialty": "static-1.2423",
  "property-description-translator": "static-1.4089",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3388",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4568",
  "jasmine-runner": "static-1.6699",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4828",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1046",
  "quartz-head": "static-1.1036",
  "quartz-i18n": "static-1.1046",
  "quartz-routing": "static-1.801",
  "quartz-test": "static-1.1046",
  "quartz-tracking": "static-1.750",
  "trellis-components": "static-1.2496",
  "ui-fonts": "static-1.995",
  "usage-tracker-container": "static-1.7596",
  "usage-tracker-core": "static-1.7456",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7499",
  "reference-resolvers": "static-1.8432",
  "sanitize-text": "static-1.8400",
  "PatternValidationJS": "static-1.3147",
  "ReduxMessenger": "static-2.10616",
  "sanitize": "static-1.4726",
  "outpost": "static-1.4411",
  "rpc-client-utils": "static-1.4913",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4660",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9677",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2477",
  "bend-plugin-foundations-theming": "static-1.3190",
  "foundations-theming-base": "static-1.3692",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.258",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9594",
  "atom": "static-1.5335",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8134",
  "ContentUtils": "static-1.69060",
  "data-token-picker": "static-1.16816",
  "file-manager-components": "static-1.24367",
  "FileManagerCore": "static-1.39866",
  "FileManagerLib": "static-1.40007",
  "frontend-preferences-client": "static-1.8178",
  "hub-http-contrib": "static-1.3290",
  "interframe": "static-3.5007",
  "layout-dnd-components": "static-1.12893",
  "layout-dnd-utils": "static-1.11868",
  "property-translator": "static-1.5645",
  "react-codemirror": "static-1.10890",
  "react-colorpicker": "static-2.10458",
  "reference-resolvers-lite": "static-1.8350",
  "rich-text-lib": "static-1.20239",
  "tinymce-data": "static-1.41092",
  "tinymce-themes": "static-1.56977",
  "ui-addon-emoji-picker": "static-1.10135",
  "ui-addon-sales-email": "static-1.5465",
  "ui-brand-identity-lib": "static-1.16229",
  "bender-build-tools": "static-1.3358",
  "hub-http-shared-msw-handlers": "static-1.10531",
  "hubspotter-http-shared-msw-handlers": "static-1.10529",
  "usage-tracker-session-replay": "static-1.5292",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1213",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.323",
  "chirp-fetch": "static-1.2141",
  "chatspot-core": "static-1.22652",
  "copilot-toolkit": "static-1.11748",
  "customer-data-objects-ui-components": "static-1.13280",
  "data-fetching-client": "static-1.9907",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5007",
  "ui-addon-video-player": "static-1.8954",
  "ui-coaching-tips": "static-1.29219",
  "usage-tracker": "static-1.7606",
  "cms-field-types": "static-1.5066",
  "content-icons-ui": "static-1.2314",
  "integrations-lib": "static-1.16931",
  "customer-data-objects": "static-1.7937",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1577",
  "apollo-link-hub-http": "static-2.4907",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4401",
  "ui-addon-iframeable": "static-1.9326",
  "video-components-external": "static-1.12065",
  "video-data-lib": "static-1.35723",
  "breeze-artifacts-sdk": "static-1.196",
  "audio-components": "static-1.6276",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29738",
  "FileManagerImages": "static-1.37518",
  "foundations-components-legacy": "static-1.1416",
  "html-to-image": "static-1.58",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9295",
  "urlinator": "static-1.4783",
  "video-components": "static-1.14067",
  "video-embed": "static-1.36557",
  "ts-schema": "static-1.4259",
  "ContentData": "static-1.69135",
  "layout-data-lib": "static-1.10193",
  "react-dnd-compat": "static-1.4866",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1793",
  "external-options-client-types": "static-1.4304",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7143",
  "hs-promise-utils": "static-1.5847",
  "inbound-db-properties-service-client": "static-1.4022",
  "NamespacedHubStyle": "static-2.9227",
  "growth-onboarding-confetti": "static-1.3311",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11395",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5721",
  "magpie-types": "static-1.5181",
  "simple-logging-lib": "static-1.3300",
  "avatar-components": "static-1.2747",
  "customer-data-ui-utilities": "static-1.10076",
  "growth-onboarding-feedback-components": "static-1.6834",
  "flux-actions": "static-1.360",
  "hubspot-apollo-client": "static-1.5129",
  "integrations-error-boundary-lib": "static-1.14346",
  "integrations-tracking-lib": "static-1.5858",
  "laboratory-lib": "static-3.7402",
  "native-integrations-shared-strings": "static-1.8027",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10513",
  "unified-auth": "static-1.809",
  "breeze-engine-chat-components": "static-1.555",
  "breeze-engine-core": "static-1.855",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8045",
  "content-media-composition-data-lib": "static-1.13120",
  "content-media-compositions": "static-2.17127",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19338",
  "unified-auth-core-lib": "static-1.1091",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15512",
  "advanced-menus-lib": "static-1.12392",
  "ExportDialog": "static-6.10630",
  "ui-memberships-settings-lib": "static-1.34734",
  "conditional-properties-service-client": "static-1.3980",
  "crm-pipelines-api-client-types": "static-1.4313",
  "fdsr-migration-layer": "static-1.262",
  "framework-builder-read-service-client": "static-1.4185",
  "framework-data-schema-quick-fetch": "static-1.7048",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3873",
  "persist-promise": "static-1.3950",
  "foundations-components-test-utils": "static-1.5874",
  "reactive-lib": "static-1.971",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.588",
  "universal-page-editor-lib": "static-1.3259",
  "adobe-sign-auth-lib": "static-1.359",
  "ads-unified-auth-lib": "static-1.1064",
  "google-sheets-integration-lib": "static-1.936",
  "microsoft-drive-auth-lib": "static-1.28",
  "surveymonkey-integration-lib": "static-1.380",
  "slack-ui-library": "static-1.10648",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3989",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15511",
  "simple-menus-lib": "static-1.17028",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.9995",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30716",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55226",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8277",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11733",
  "I18n": "/I18n/static-7.1663",
  "quartz": "/quartz/static-1.7371",
  "quartz-config": "/quartz-config/static-1.1149",
  "quartz-core": "/quartz-core/static-1.6590",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.871",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55213",
  "feedback-utils": "/feedback-utils/static-1.55217",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4716",
  "forms-utils-lib": "/forms-utils-lib/static-1.13023",
  "foundations-assets": "/foundations-assets/static-1.5128",
  "foundations-components": "/foundations-components/static-1.8391",
  "foundations-theming": "/foundations-theming/static-1.4707",
  "hub-http": "/hub-http/static-1.6464",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12040",
  "icons": "/icons/static-2.674",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4097",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.8",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5519",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tinymce-plugins": "/tinymce-plugins/static-1.58121",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1230",
  "UIComponents": "/UIComponents/static-3.8679",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3581",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3648",
  "quartz-webpack": "/quartz-webpack/static-1.3595",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2423",
  "property-description-translator": "/property-description-translator/static-1.4089",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3388",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4568",
  "jasmine-runner": "/jasmine-runner/static-1.6699",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4828",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1046",
  "quartz-head": "/quartz-head/static-1.1036",
  "quartz-i18n": "/quartz-i18n/static-1.1046",
  "quartz-routing": "/quartz-routing/static-1.801",
  "quartz-test": "/quartz-test/static-1.1046",
  "quartz-tracking": "/quartz-tracking/static-1.750",
  "trellis-components": "/trellis-components/static-1.2496",
  "ui-fonts": "/ui-fonts/static-1.995",
  "usage-tracker-container": "/usage-tracker-container/static-1.7596",
  "usage-tracker-core": "/usage-tracker-core/static-1.7456",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7499",
  "reference-resolvers": "/reference-resolvers/static-1.8432",
  "sanitize-text": "/sanitize-text/static-1.8400",
  "PatternValidationJS": "/PatternValidationJS/static-1.3147",
  "ReduxMessenger": "/ReduxMessenger/static-2.10616",
  "sanitize": "/sanitize/static-1.4726",
  "outpost": "/outpost/static-1.4411",
  "rpc-client-utils": "/rpc-client-utils/static-1.4913",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4660",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9677",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2477",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3190",
  "foundations-theming-base": "/foundations-theming-base/static-1.3692",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.258",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9594",
  "atom": "/atom/static-1.5335",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8134",
  "ContentUtils": "/ContentUtils/static-1.69060",
  "data-token-picker": "/data-token-picker/static-1.16816",
  "file-manager-components": "/file-manager-components/static-1.24367",
  "FileManagerCore": "/FileManagerCore/static-1.39866",
  "FileManagerLib": "/FileManagerLib/static-1.40007",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8178",
  "hub-http-contrib": "/hub-http-contrib/static-1.3290",
  "interframe": "/interframe/static-3.5007",
  "layout-dnd-components": "/layout-dnd-components/static-1.12893",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11868",
  "property-translator": "/property-translator/static-1.5645",
  "react-codemirror": "/react-codemirror/static-1.10890",
  "react-colorpicker": "/react-colorpicker/static-2.10458",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8350",
  "rich-text-lib": "/rich-text-lib/static-1.20239",
  "tinymce-data": "/tinymce-data/static-1.41092",
  "tinymce-themes": "/tinymce-themes/static-1.56977",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10135",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5465",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16229",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10531",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10529",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5292",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1213",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.323",
  "chirp-fetch": "/chirp-fetch/static-1.2141",
  "chatspot-core": "/chatspot-core/static-1.22652",
  "copilot-toolkit": "/copilot-toolkit/static-1.11748",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13280",
  "data-fetching-client": "/data-fetching-client/static-1.9907",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5007",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8954",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29219",
  "usage-tracker": "/usage-tracker/static-1.7606",
  "cms-field-types": "/cms-field-types/static-1.5066",
  "content-icons-ui": "/content-icons-ui/static-1.2314",
  "integrations-lib": "/integrations-lib/static-1.16931",
  "customer-data-objects": "/customer-data-objects/static-1.7937",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1577",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4907",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4401",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9326",
  "video-components-external": "/video-components-external/static-1.12065",
  "video-data-lib": "/video-data-lib/static-1.35723",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.196",
  "audio-components": "/audio-components/static-1.6276",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29738",
  "FileManagerImages": "/FileManagerImages/static-1.37518",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1416",
  "html-to-image": "/html-to-image/static-1.58",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9295",
  "urlinator": "/urlinator/static-1.4783",
  "video-components": "/video-components/static-1.14067",
  "video-embed": "/video-embed/static-1.36557",
  "ts-schema": "/ts-schema/static-1.4259",
  "ContentData": "/ContentData/static-1.69135",
  "layout-data-lib": "/layout-data-lib/static-1.10193",
  "react-dnd-compat": "/react-dnd-compat/static-1.4866",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1793",
  "external-options-client-types": "/external-options-client-types/static-1.4304",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7143",
  "hs-promise-utils": "/hs-promise-utils/static-1.5847",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4022",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9227",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3311",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11395",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5721",
  "magpie-types": "/magpie-types/static-1.5181",
  "simple-logging-lib": "/simple-logging-lib/static-1.3300",
  "avatar-components": "/avatar-components/static-1.2747",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10076",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6834",
  "flux-actions": "/flux-actions/static-1.360",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5129",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14346",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5858",
  "laboratory-lib": "/laboratory-lib/static-3.7402",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8027",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10513",
  "unified-auth": "/unified-auth/static-1.809",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.555",
  "breeze-engine-core": "/breeze-engine-core/static-1.855",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8045",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13120",
  "content-media-compositions": "/content-media-compositions/static-2.17127",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19338",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1091",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15512",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12392",
  "ExportDialog": "/ExportDialog/static-6.10630",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34734",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3980",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4313",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.262",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4185",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7048",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3873",
  "persist-promise": "/persist-promise/static-1.3950",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5874",
  "reactive-lib": "/reactive-lib/static-1.971",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.588",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3259",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.359",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1064",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.936",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.28",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.380",
  "slack-ui-library": "/slack-ui-library/static-1.10648",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3989",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15511",
  "simple-menus-lib": "/simple-menus-lib/static-1.17028",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9995",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
